module.exports = __webpack_public_path__ + "img/icon_good.bfa06f13.png";